{
  "alert": "Alerta",
  "dismiss": "Dispensar"
}
